//
//
//
//
//
//
//
//
//
//
//

/**
 * @typedef {{
 *   baseUrl: string
 *   tidalUrl?: string
 *   nuxtLinks?: string[]
 * }} ParentProps
 **/

export default {
    inheritAttrs: false,
    props: {
        href: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        nuxt: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {ParentProps} */
        parentProps() {
            return /** @type {ParentProps} parentProps */(this.$parent && this.$parent.$options.propsData) || {};
        },
        /** @return {boolean} */
        isExternal() {
            return this.href.startsWith('http');
        },
        /** @return {boolean} */
        isNuxt() {
            if (this.isExternal) {
                return false;
            }

            return !!this.parentProps.nuxtLinks && this.parentProps.nuxtLinks.includes(this.nuxt || this.href);
        },
        /** @return {string | null} */
        _href() {
            if (this.disabled) {
                return null;
            }

            const href = this.href && this.href !== '/' ? this.href : '';
            if (this.isExternal) {
                return href;
            }

            const baseUrl = this.parentProps.baseUrl || '/';

            if (this.isNuxt) {
                return baseUrl + href;
            }

            if (href === baseUrl) {
                return href;
            }

            return (this.parentProps.tidalUrl || baseUrl) + href;
        },
    },
};
